// extracted by mini-css-extract-plugin
export default {"GeoButton":"Button_GeoButton__OaZSV"};